module.exports = __webpack_public_path__ + "static/britishrowing-69cc1c569f1b7b6de68a965bc5b22d5e.svg";